import React, { useState } from 'react';
import css from './LinkTalentPage.module.css';
import { Button, NamedLink } from '../../components';
import LinkTalentModal from './LinkTalentModal/LinkTalentModal';
import { FormattedMessage } from 'react-intl';
import { getListingAssociatedUsers } from '../../util/listingDataExtraction';
import LinkedTalentsTable from './LinkedTalentsTable';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { LinkTalentTabs } from '../../util/enums';

const LinkTalentPanel = ({
  currentUser,
  currentUserListing,
  userType,
  history,
  routeConfiguration,
}) => {
  const [isLinkModalOpen, setIsLinkModalOpen] = useState(false);
  const params = useParams();
  const currentUserId = currentUser?.id?.uuid || null;
  const nonInvitableUserIds = [...(currentUserId ? [currentUserId] : [])];
  const listingTitle = currentUserListing?.attributes?.title || '';
  const associatedUsers = getListingAssociatedUsers(currentUserListing);
  const tab = params.tab || LinkTalentTabs.LINK;
  return (
    <div className={css.invitationPanel}>
      {tab === LinkTalentTabs.VIEW && (
        <LinkedTalentsTable
          associatedUsers={associatedUsers}
          currentUserListing={currentUserListing}
          history={history}
          routeConfiguration={routeConfiguration}
          listingTitle={listingTitle}
        />
      )}
      {tab === LinkTalentTabs.LINK && (
        <div className={css.panelContent}>
          <h2 className={css.panelHeading}>
            <FormattedMessage id="LinkTalentPanel.heading" values={{ listingTitle }} />
          </h2>
          <p className={css.panelDescription}>
            <FormattedMessage id="LinkTalentPanel.description" values={{ listingTitle }} />
          </p>
          <div className={css.talentPanelBtn}>
            <Button
              type="button"
              className={css.invitationButton}
              onClick={() => setIsLinkModalOpen(true)}
            >
              <FormattedMessage id="LinkTalentPanel.linkTalent" defaultMessage="Link Talent" />
            </Button>

            <NamedLink
              className={css.viewTalentBtn}
              name="LinkTalentPage"
              params={{ tab: LinkTalentTabs.VIEW }}
            >
              <FormattedMessage id="LinkedTalentsTable.viewTalents" defaultMessage="View talents" />
            </NamedLink>
          </div>
        </div>
      )}

      <LinkTalentModal
        isOpen={isLinkModalOpen}
        onClose={() => setIsLinkModalOpen(false)}
        nonInvitableUserIds={nonInvitableUserIds}
        currentUserListing={currentUserListing}
        userType={userType}
        isLinkTalentModal={true}
        listingTitle={listingTitle}
      />
    </div>
  );
};

export default LinkTalentPanel;
